import { Grid } from '@mui/material';
import { set } from 'lodash';
import {
  ColorPickerWidget,
  NumberInputWidget,
  SelectDropdownWidget,
  SwitchButtonWidget,
} from 'src/components/widget';
import { FONT_FAMILY_OPTIONS } from 'src/constants';
import { useGetProjectConfig } from 'src/hooks';
import type { IGcfBadge } from 'src/interfaces';
import { lang } from 'src/utils';

import { generateBadgeSizeOption } from '../helper';
import type { ImageBadgeControllerProps } from './ImageBadgeController.interface';

export const ImageBadgeController = (props: ImageBadgeControllerProps) => {
  const { data: projectConfig } = useGetProjectConfig();

  const projectFonts =
    projectConfig?.fonts?.map((item) => ({
      label: item.name,
      value: item.name,
    })) ?? [];
  const mappedFonts =
    projectFonts.length > 0 ? projectFonts : FONT_FAMILY_OPTIONS;

  const handleChange = (field: string) => (value: any) => {
    props.handleChange(set({ ...props.value } as IGcfBadge, field, value));
  };

  return (
    <Grid container spacing={2}>
      {props?.options?.showVisible && (
        <Grid item xs={12}>
          <SwitchButtonWidget
            value={props.value?.visible}
            onChange={handleChange('visible')}
          />
        </Grid>
      )}

      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.fontFamily}
          value={
            props.value?.style?.font ??
            props.currentTheme?.config.badges?.imageBadge?.font
          }
          selectOptions={mappedFonts}
          onChange={handleChange('style.font')}
        />
      </Grid>

      <Grid item xs={6}>
        <NumberInputWidget
          label={lang.fontSize}
          value={
            props.value?.style?.fontSize ??
            props.currentTheme?.config.badges?.imageBadge?.fontSize
          }
          onChange={handleChange('style.fontSize')}
          options={{ suffix: 'px' }}
        />
      </Grid>

      <Grid item xs={12}>
        <ColorPickerWidget
          label={lang.fontColor}
          value={
            props.value?.style?.color ??
            props.currentTheme?.config.badges?.imageBadge?.color
          }
          onChange={handleChange('style.color')}
          colorPickerMode="block"
          pickerWrapperStyle={{ left: '0', top: '-200px' }}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.badgeSize}
          value={
            props.value?.style?.size ??
            props.currentTheme?.config.badges?.imageBadge?.size
          }
          selectOptions={generateBadgeSizeOption(150)}
          onChange={handleChange('style.size')}
          options={{ suffix: 'px' }}
        />
      </Grid>

      <Grid item xs={6}>
        <ColorPickerWidget
          label={lang.badgeBackground}
          value={
            props.value?.style?.backgroundColor ??
            props.currentTheme?.config.badges?.imageBadge?.backgroundColor
          }
          onChange={handleChange('style.backgroundColor')}
          options={{
            backgroundColor: true,
            hideAIcon: true,
            triangle: 'hide',
          }}
          colorPickerMode="block"
          pickerWrapperStyle={{ left: '0', top: '-200px' }}
        />
      </Grid>
    </Grid>
  );
};
